import React from 'react';
import { Link } from 'react-router-dom';

const CourseCard = ({ course }) => {
  return (
    <div className="course-card">
      <div className="course-card-content">
        <h3>{course.title}</h3>
        <p>{course.description}</p>
        <ul className="course-features">
          {course.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
        <div className="course-price">{course.price}</div>
        <Link to={`/premium-courses/${course.id}`} className="course-button">View Details</Link>
      </div>
    </div>
  );
};

export default CourseCard;